// extracted by mini-css-extract-plugin
export default {"image":"CardInitialsImage_image__M75BM"};